import React, { lazy } from "react";
import { PATIENT_MANAGEMENT_BASE_PATH } from "@brightinsight/bi-web-dms-modules";

export class RouteConstants {
  static Form = lazy(
    () =>
      import(
        /* webpackChunkName: "Patient-mangement" */ "../layout/PatientManagement"
      )
  );

  // Define module routes for the patients module
  static readonly MODULE_ROUTES = [
    {
      path: `${PATIENT_MANAGEMENT_BASE_PATH}/invite`, // URL path for the patients management
      component: React.createElement(RouteConstants.Form, { type: "Add" }), // Component to render for this route
      actionName: "add", // Action name associated with this route
      displayName: "Patients Add", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
    {
      path: `${PATIENT_MANAGEMENT_BASE_PATH}/:id/details`, // URL path for the patients management
      component: React.createElement(RouteConstants.Form, { type: "View" }), // Component to render for this route
      actionName: "view", // Action name associated with this route
      displayName: "Patients View", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
    {
      path: `${PATIENT_MANAGEMENT_BASE_PATH}/:id/edit`, // URL path for the patients management
      component: React.createElement(RouteConstants.Form, { type: "Edit" }), // Component to render for this route
      actionName: "edit", // Action name associated with this route
      displayName: "Patients Edit", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
  ];
}
